/* collection - infinite-scroll duplicate-insert guard */

(function () {
  'use strict';

  var CARD = '[ref="cards[]"]';
  var guarded = [];

  function isCollection() {
    return !!document.body && document.body.classList.contains('template-collection');
  }

  function liveCards(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > ' + CARD));
  }

  function keepFresh(grid, nodes) {
    var seen = new Set();

    liveCards(grid).forEach(function (card) {
      if (card.dataset.productId) seen.add(card.dataset.productId);
    });

    return nodes.filter(function (node) {
      if (!(node instanceof Element) || !node.matches(CARD)) return true;

      var id = node.dataset.productId;
      if (!id) return true;
      if (seen.has(id)) return false;

      seen.add(id);
      return true;
    });
  }

  function guardGrid(grid) {
    if (grid.ygInsertGuard) return;
    grid.ygInsertGuard = true;

    ['append', 'prepend'].forEach(function (op) {
      var original = Object.getPrototypeOf(grid)[op];

      Object.defineProperty(grid, op, {
        configurable: true,
        value: function () {
          var kept = keepFresh(grid, Array.prototype.slice.call(arguments));
          if (!kept.length) return undefined;
          return original.apply(grid, kept);
        },
      });
    });
  }

  function releaseGrid(grid) {
    if (!grid.ygInsertGuard) return;
    delete grid.append;
    delete grid.prepend;
    grid.ygInsertGuard = false;
  }

  function guardRefs(list, grid) {
    if (list.ygRefsGuard) return;

    var stored = list.refs;
    if (!stored) return;

    list.ygRefsGuard = true;

    Object.defineProperty(list, 'refs', {
      configurable: true,
      get: function () {
        if (!stored) return stored;

        return new Proxy(stored, {
          get: function (target, key) {
            return key === 'cards' ? liveCards(grid) : target[key];
          },
        });
      },
      set: function (value) {
        stored = value;
      },
    });

    return function () {
      var raw = stored;
      delete list.refs;
      list.refs = raw;
      list.ygRefsGuard = false;
    };
  }

  function apply(root) {
    var lists = (root || document).querySelectorAll('results-list');

    Array.prototype.forEach.call(lists, function (list) {
      var grid = list.querySelector('[ref="grid"]');
      if (!grid) return;

      guardGrid(grid);
      var releaseRefs = guardRefs(list, grid);

      guarded.push({
        list: list,
        release: function () {
          releaseGrid(grid);
          if (releaseRefs) releaseRefs();
        },
      });
    });
  }

  function onSectionLoad(event) {
    if (!isCollection()) return;
    apply(event.target);
  }

  function onSectionUnload(event) {
    guarded = guarded.filter(function (entry) {
      if (!event.target.contains(entry.list)) return true;

      entry.release();
      return false;
    });
  }

  function start() {
    if (!isCollection() || !window.customElements) return;

    customElements.whenDefined('results-list').then(function () {
      apply(document);
    });

    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
